import {
  Tax,
} from '@dapi/sdk';
import {
  currency,
  currencyCode,
  inrCurrency,
  sekCurrency,
} from './currency';

/**
 * In case of multiple passengers, in total price, values are (unit prices * numberOfPassengers)
 * To make sure mocks have correct valued for taxes, and to make that computation easier this function can be used.
 * It multiplies the values of each tax by the multiplier provided and returned the new Tax array
 *
 * @param taxList list of taxes
 * @param multiplier number to multiply it by, default value is 1
 */
function multiplyTaxValues(taxList: Tax[], multiplier = 1): Tax[] {
  return taxList.map((tax) => ({
    ...tax,
    value: tax.value * multiplier
  }));
}

/** Taxes */
export const refundableTax: Tax = {
  value: 2229,
  currencyCode,
  currency,
  code: 'ZOAE'
};

export const taxes: Tax[] = [refundableTax];

export const multicurrencyTaxes: Tax[] = [
  refundableTax,
  {
    value: 695,
    currencyCode,
    currency,
    code: 'G2AP'
  },
  {
    value: 991,
    currencyCode,
    currency,
    code: 'ZNAE'
  }
];

export const multipleTaxes: Tax[] = [
  {
    value: 75,
    currencyCode: 'AED',
    currency,
    code: 'G2AP'
  },
  {
    value: 40,
    currencyCode: 'AED',
    currency,
    code: 'ZNAE'
  },
  {
    value: 5,
    currencyCode: 'AED',
    currency,
    code: 'G2AP'
  },
  {
    value: 5,
    currencyCode: 'AED',
    currency,
    code: 'ZNAE'
  },
  {
    value: 90,
    currencyCode: 'AED',
    currency,
    code: 'G2AP'
  },
  {
    value: 20,
    currencyCode: 'AED',
    currency,
    code: 'ZNAE'
  },
  {
    value: 30,
    currencyCode: 'AED',
    currency,
    code: 'G2AP'
  },
  {
    value: 30,
    currencyCode: 'AED',
    currency,
    code: 'ZNAE'
  }
];

export const multipleTaxesForAmop: Tax[] = [
  {
    value: 500,
    currencyCode: 'AED',
    currency,
    code: 'E7'
  },
  {
    value: 5000,
    currencyCode: 'AED',
    currency,
    code: 'G1'
  },
  {
    value: 200,
    currencyCode: 'AED',
    currency,
    code: 'G8'
  },
  {
    value: 100,
    currencyCode: 'AED',
    currency,
    code: 'H8'
  },
  {
    value: 7300,
    currencyCode: 'AED',
    currency,
    code: 'MY'
  },
  {
    value: 4000,
    currencyCode: 'AED',
    currency,
    code: 'YQ'
  }
];

export const multipleTaxesForVoucher: Tax[] = [
  {
    value: 31_400,
    currencyCode: 'INR',
    currency,
    code: 'K3'
  },
  {
    value: 23_600,
    currencyCode: 'INR',
    currency,
    code: 'P2'
  },
  {
    value: 11_800,
    currencyCode: 'INR',
    currency,
    code: 'YM'
  },
  {
    value: 16_000,
    currencyCode: 'INR',
    currency,
    code: 'YR'
  },
  {
    value: 1000,
    currencyCode: 'INR',
    currency,
    code: 'YR'
  }
];

export const multipleTaxesWithMultipleVouchers: Tax[] = [
  {
    value: 296_100,
    currencyCode: 'INR',
    currency,
    code: 'K3'
  },
  {
    value: 23_600,
    currencyCode: 'INR',
    currency,
    code: 'P2'
  },
  {
    value: 11_800,
    currencyCode: 'INR',
    currency,
    code: 'YM'
  },
  {
    value: 16_000,
    currencyCode: 'INR',
    currency,
    code: 'YR'
  },
  {
    value: 1000,
    currencyCode: 'INR',
    currency,
    code: 'YR'
  }
];

export const multipleTaxesForVoucher3: Tax[] = [
  {
    value: 281_100,
    currencyCode: 'INR',
    currency,
    code: 'K3'
  },
  {
    value: 23_600,
    currencyCode: 'INR',
    currency,
    code: 'P2'
  },
  {
    value: 11_800,
    currencyCode: 'INR',
    currency,
    code: 'YM'
  },
  {
    value: 16_000,
    currencyCode: 'INR',
    currency,
    code: 'YR'
  },
  {
    value: 1000,
    currencyCode: 'INR',
    currency,
    code: 'YR'
  }
];

export const multipleTaxesForMiles: Tax[] = [
  {
    value: 1000,
    currencyCode: 'SEK',
    currency,
    code: 'DESE'
  },
  {
    value: 1553,
    currencyCode: 'SEK',
    currency,
    code: 'OYCB'
  },
  {
    value: 3245,
    currencyCode: 'SEK',
    currency,
    code: 'RAEB'
  },
  {
    value: 27,
    currencyCode: 'SEK',
    currency,
    code: 'BEEB'
  }
];

export const multipleTaxesForMilesWithTwoPax = multiplyTaxValues(multipleTaxesForMiles, 2);

export const taxesForMultiBoundRebooking: Tax[] = [
  {
    value: 8600,
    currencyCode,
    currency,
    code: 'YR'
  },
  {
    value: 976,
    currencyCode,
    currency,
    code: 'DQ'
  },
  {
    value: 1776,
    currencyCode,
    currency,
    code: 'QU'
  },
  {
    value: 200,
    currencyCode,
    currency,
    code: 'XU'
  },
  {
    value: 5996,
    currencyCode,
    currency,
    code: 'YF'
  }
];

export const arnEwrTaxes: Tax[] = [
  {
    value: 1200,
    currency: sekCurrency,
    currencyCode: 'SEK',
    code: 'YQAC'
  },
  {
    value: 260,
    currencyCode: 'SEK',
    currency: sekCurrency,
    code: 'LJAV'
  },
  {
    value: 161,
    currencyCode: 'SEK',
    currency: sekCurrency,
    code: 'YAAD'
  },
  {
    value: 35,
    currencyCode: 'SEK',
    currency: sekCurrency,
    code: 'XACO'
  },
  {
    value: 61,
    currencyCode: 'SEK',
    currency: sekCurrency,
    code: 'XYCR'
  },
  {
    value: 51,
    currencyCode: 'SEK',
    currency: sekCurrency,
    code: 'YCAE'
  }
];

export const multipleTaxesForCard: Tax[] = [
  {
    value: 8600,
    currency: inrCurrency,
    currencyCode: 'INR',
    code: 'YR'
  },
  {
    value: 976,
    currencyCode: 'INR',
    currency: inrCurrency,
    code: 'DQ'
  },
  {
    value: 1776,
    currencyCode: 'INR',
    currency: inrCurrency,
    code: 'QU'
  },
  {
    value: 200,
    currencyCode: 'INR',
    currency: inrCurrency,
    code: 'XU'
  },
  {
    value: 5996,
    currencyCode: 'INR',
    currency: inrCurrency,
    code: 'YF'
  }
];

export const multipleTaxesForCard2: Tax[] = [
  {
    value: 8600,
    currency: inrCurrency,
    currencyCode: 'INR',
    code: 'YR'
  },
  {
    value: 976,
    currencyCode: 'INR',
    currency: inrCurrency,
    code: 'DQ'
  },
  {
    value: 1776,
    currencyCode: 'INR',
    currency: inrCurrency,
    code: 'QU'
  },
  {
    value: 200,
    currencyCode: 'INR',
    currency: inrCurrency,
    code: 'XU'
  },
  {
    value: 4786,
    currencyCode: 'INR',
    currency: inrCurrency,
    code: 'YF'
  }
];

export const taxesForPaidAmountWithMiles: Tax[] = [
  {
    value: 946,
    currencyCode: 'SEK',
    currency: sekCurrency,
    code: 'CA'
  },
  {
    value: 4000,
    currencyCode: 'SEK',
    currency: sekCurrency,
    code: 'SQ'
  },
  {
    value: 247,
    currencyCode: 'SEK',
    currency: sekCurrency,
    code: 'XG'
  },
  {
    value: 493,
    currencyCode: 'SEK',
    currency: sekCurrency,
    code: 'XQ'
  }
];

export const taxesForPaidAmount: Tax[] = [
  {
    value: 1186,
    currencyCode: 'EUR',
    currency,
    code: 'DE'
  },
  {
    value: 1577,
    currencyCode: 'EUR',
    currency,
    code: 'GB'
  },
  {
    value: 1553,
    currencyCode: 'EUR',
    currency,
    code: 'OY'
  },
  {
    value: 4070,
    currencyCode: 'EUR',
    currency,
    code: 'RA'
  },
  {
    value: 2829,
    currencyCode: 'EUR',
    currency,
    code: 'UB'
  },
  {
    value: 400,
    currencyCode: 'EUR',
    currency,
    code: 'YQ'
  },
  {
    value: 3400,
    currencyCode: 'EUR',
    currency,
    code: 'YQ'
  }
];
